import React from 'react'
import { BsTelephone } from "react-icons/bs";
import {Helmet} from 'react-helmet-async';

const Parking = () => {
  return (
    <>
    <Helmet>
      <title>Parking</title>
      <meta name='description' content="Vehicle Parking at Coimbatore International Airport."/>
      <link rel="canonical" href="/parking"/>
    </Helmet>
    <p className='d-flex justify-content-center fs-4 fw-bold'>Parking Charges for different vehicles</p>
     <table className="table table-striped table-hover table-bordered table-sm">
     <thead>
    <tr>
      <th scope="col">Vehicle Type</th>
      <th scope="col">Charges Upto 2 Hours</th>
      
    </tr>
  </thead>
  <tbody className="table-group-divider">
    <tr>
      <th scope="row">Two Wheeler</th>
      
      <td>Rs.15/-</td>
      
    </tr>
    <tr>
      <th scope="row">Car / Van</th>
      
      <td>Rs.55/-</td>
      
      
      
    </tr>
    <tr>
      <th scope="row">Tempo/SUV/Minibus</th>
      
      <td >Rs.60/-</td>
      
      
    </tr>
    <tr>
      <th scope="row">Coach/Bus/Truck</th>
      
      <td >Rs.70/-</td>
      
      
    </tr>
  </tbody>
</table>


<p className='d-flex justify-content-center fs-5 mx-2'>The rates will be applicable for 2 hours.  After 2 hours, rate will increase by Rs.10/- per hour (except two wheelers).
For Two Wheeler. the charge after 2  hours will be Rs.5/- per hour.
The parking rate beyond 7 hours upto 24 hours will be 300% of the first two hour rate and every 24 hours or part thereof.</p>

<p className='d-flex justify-content-center fs-4 fw-bold'>Overnight Parking Charges for different vehicles</p>
<p className='d-flex justify-content-center fs-5'>Car Parking Fee for 24 Hrs. = Rs.165/-</p>
<p className='d-flex justify-content-center fs-5'>SUV Car Parking Fee for 24 Hrs. = Rs.180/-</p>
<p className='d-flex justify-content-center fs-5'><BsTelephone/>Customer Care No. : <a href="tel:+4222591905">0422-2591905 </a> / <a href="tel:+9442191902"> 9442191902</a></p><br/>

<p className='d-flex justify-content-start align-items-start fs-5 fw-semibold mx-2'><strong>Note</strong>: Car Parking is available in front of Airport Terminal Building. Please inform the Parking staff that you will Leave your Vehicle for Overnight Parking.</p>



    </>
  )
}

export default Parking